export const LOGIN_ENDPOINT = process.env.REACT_APP_LOGIN_ENDPOINT;
export const LOGIN_PRODUCT_ID = process.env.REACT_APP_LOGIN_PRODUCT_ID;
export const LOGIN_TENANT_ID = process.env.REACT_APP_LOGIN_TENANT_ID;
export const PLATFORM = process.env.REACT_APP_PLATFORM;
export const ISD_CODE = process.env.REACT_APP_ISD_CODE;
export const REQUEST_PRODUCT_ID = process.env.REACT_APP_REQUEST_PRODUCT_ID;

export const OFFERING_TYPE = [
  { value: "Product", label: "Product" },
  { value: "Service", label: "Service" },
];

export const PRODUCT = "Product";
export const SERVICE = "Service";

export const FEATURES = [
  { id: "1", value: "LIVE_CLASSES", label: "Live Classes" },
  { id: "2", value: "RECORDED_CLASSES", label: "Recorded Classes" },
  { id: "3", value: "SELF_LEARN_FULL_MODULE", label: "Self Learn Full Module" },
  { id: "4", value: "TIME_BOUND_TESTS", label: "Time Bound Tests" },
  { id: "5", value: "MOCK_TESTS", label: "Mock Tests" },
  {
    id: "6",
    value: "ASSESSMENTS_FULL_MODULE",
    label: "Assessments Full Module",
  },
  { id: "7", value: "DOUBTS", label: "Doubts" },
  { id: "8", value: "BOOKS", label: "Books" },
];

export const SERVICE_OFFERINGS = [
  { id: "1", value: "Service offering 1", label: "Service offering 1" },
  { id: "2", value: "Service offering 2", label: "Service offering 2" },
  { id: "3", value: "Service offering 3", label: "Service offering 3" },
  { id: "4", value: "Service offering 4", label: "Service offering 4" },
];
export const PRODUCT_OFFERINGS = [
  { id: "1", value: "Product offering 1", label: "Product offering 1" },
  { id: "2", value: "Product offering 2", label: "Product offering 2" },
  { id: "3", value: "Product offering 3", label: "Product offering 3" },
  { id: "4", value: "Product offering 4", label: "Product offering 4" },
];

export const DURATION_TYPES = [
  { id: 1, value: "SECOND", label: "Second" },
  { id: 2, value: "MINUTE", label: "Minute" },
  { id: 3, value: "HOUR", label: "Hour" },
  { id: 4, value: "DAYS", label: "Days" },
  { id: 5, value: "WEEKS", label: "Weeks" },
  { id: 6, value: "MONTHS", label: "Months" },
  { id: 7, value: "YEARS", label: "Years" },
];
export const DEFAULT_PRODUCT = {
   productOffering:{},
   description: "",
   quantity: "",
}
export const DEFAULT_SERVICE = {
   feature:{},
   offering:{},
   description:"",
   quantity:"",
   duration:"",
   durationType:{},
   usageDate:{},
}
